export const processLayout = (layoutData, nestedGridData, layout, convertFieldToEmpty = false) => {
  let elements = [];
  let uniqueFields = [];
  let uniqueIds = [];

  const processElement = (item) => {
    const elementConfig = JSON.parse(JSON.stringify(layoutData.current[item.i]));
    //TODO: remove deep copy in future
    // const elementConfig = { ...layoutData.current[item.i] };
    let element = {
      grid: item,
      element_config: elementConfig
    };
    uniqueIds.push(element.element_config.i);

    if (convertFieldToEmpty && (elementConfig.type === "field" || elementConfig.type === "variable")) {
      element = {
        grid: item,
        element_config: {
          id: item.i,
          i: item.i,
          className: elementConfig.className || {},
          inline_style: elementConfig.inline_style || {},
          custom_css: elementConfig.custom_css || "",
          icon: elementConfig.icon || "",
          placeholder: elementConfig.placeholder || "",
          colorif: [],
          type: "empty",
          display: "empty field"
        }
      };
      return element;
    }

    if (elementConfig.type === "tabview") {
      elementConfig.config.headerData.forEach((header) => {
        const bodyData = nestedGridData.current[header.id].map(processElement);
        element.element_config.config.bodyData[header.id] = bodyData;
        uniqueIds.push(header.id);
      });
    }

    if (elementConfig.type === "section") {
      const nestedElements = nestedGridData.current[item.i].map(processElement);
      element.element_config.config.layouts = nestedElements;
    }

    if (elementConfig.type === "field") {
      const dataKey = element.element_config.data_key;
      if (dataKey && !uniqueFields.includes(dataKey)) {
        uniqueFields.push(dataKey);
      }
    }

    if (elementConfig.type === "custom-component") {
      elementConfig.config.props?.forEach((prop) => {
        const dataKey = prop?.mapped_data?.data_key;
        if (dataKey && !uniqueFields.includes(dataKey)) {
          uniqueFields.push(dataKey);
        }
      });
    }

    return element;
  };

  elements = layout.map(processElement);
  return { elements, uniqueFields, uniqueIds };
};

export const newProcessLayout = (layoutData, nestedGridData, layout, convertFieldToEmpty = false) => {
  let elements = [];
  let uniqueFields = [];
  let uniqueIds = [];

  const processElement = (item) => {
    const elementConfig = JSON.parse(JSON.stringify(layoutData[item.i]));
    //TODO: remove deep copy in future
    // const elementConfig = { ...layoutData.current[item.i] };
    let element = {
      grid: item,
      element_config: elementConfig
    };
    uniqueIds.push(element.element_config.i);

    if (convertFieldToEmpty && (elementConfig.type === "field" || elementConfig.type === "variable")) {
      element = {
        grid: item,
        element_config: {
          id: item.i,
          i: item.i,
          className: elementConfig.className || {},
          inline_style: elementConfig.inline_style || {},
          custom_css: elementConfig.custom_css || "",
          icon: elementConfig.icon || "",
          placeholder: elementConfig.placeholder || "",
          colorif: [],
          type: "empty",
          display: "empty field"
        }
      };
      return element;
    }

    if (elementConfig.type === "tabview") {
      elementConfig.config.headerData.forEach((header) => {
        const bodyData = nestedGridData[header.id].map(processElement);
        element.element_config.config.bodyData[header.id] = bodyData;
        uniqueIds.push(header.id);
      });
    }

    if (elementConfig.type === "section") {
      const nestedElements = nestedGridData[item.i].map(processElement);
      element.element_config.config.layouts = nestedElements;
    }

    if (elementConfig.type === "field") {
      const dataKey = element.element_config.data_key;
      if (dataKey && !uniqueFields.includes(dataKey)) {
        uniqueFields.push(dataKey);
      }
    }

    if (elementConfig.type === "custom-component") {
      elementConfig.config.props?.forEach((prop) => {
        const dataKey = prop?.mapped_data?.data_key;
        if (dataKey && !uniqueFields.includes(dataKey)) {
          uniqueFields.push(dataKey);
        }
      });
    }

    return element;
  };

  elements = layout.map(processElement);
  return { elements, uniqueFields, uniqueIds };
};

export const getDropDimensionForDetailview = (item, type, device) => {
  switch (type) {
    case "button":
    case "dropdown":
      return { ...item, h: 2, w: 3 };
    case "timeline":
    case "tabview":
      return { ...item, h: 10, w: 12 };
    case "spacer":
    case "button-group":
      return { ...item, h: 3, w: 12 };
    case "tableview":
      return { ...item, h: 10, w: device === "mobile" ? 12 : 6 };
    case "mail_thread":
      return { ...item, h: 8, w: 8 };
    case "form":
      return { ...item, h: 8, w: 5 };
    case "section":
    case "recordset":
    case "recordset-list":
    case "activitycard":
    case "activity-recordsview":
    case "activity-chart":
    case "progress-bar":
      return { ...item, h: 5, w: device === "mobile" ? 12 : 6 };
    case "image":
    case "file_viewer":
      return { ...item, h: 5, w: 4 };
    case "html":
    case "dynamic-html":
    case "variable":
      return { ...item, h: 5, w: 12 };
    case "custom-component":
      return { ...item, h: 5, w: 5 };
    default:
      return { ...item, h: 1, w: 12 };
  }
};

export const getDropDimensionForScreen = (item, type) => {
  switch (type) {
    case "recordsview":
      return { ...item, h: 5, w: 12 };
    case "mapsview":
    case "tabview":
      return { ...item, h: 3, w: 12 };
    case "detailsview":
      return { ...item, h: 5, w: 12 };
    case "chart":
      return { ...item, h: 7, w: 12 };
    case "button":
    case "dropdown":
      return { ...item, h: 1, w: 3 };
    case "pivotcharts":
      return { ...item, h: 7, w: 12 };
    case "queryblocks":
    default:
      return { ...item, h: 1, w: 12 };
  }
};
